import { Column, Heading, Row, TruncatedText } from "@hex-insights/core";
import { Badge } from "../../../../../Components/Badge";
import { DetailFormModalController } from "../../../../../Components/DetailFormModal";
import { Icon } from "../../../../../Components/Icon";
import { ClassYearDetailQuery } from "../../../../../Utilities";
import { ClassYearFormat } from "../../../../Format";
import { ClassYearForm } from "../../../../Forms";

export type HeaderProps = {
	classYear: ClassYearDetailQuery["classYear"];
};

export function Header({ classYear }: HeaderProps) {
	return (
		<Row justify="space-between" align="center">
			<Column justify="spaced-start">
				<Heading.H1 noMargin>{ClassYearFormat.name(classYear)}</Heading.H1>

				<Row justify="spaced-start" align="center" style={{ padding: "0 1rem" }}>
					<Badge color="#fff" backgroundColor="var(--theme-colors__blue)">
						<Row justify="spaced-start" align="center" horizontalSpacing="0.25rem">
							<Icon.GraduationCap size={14} />
							<TruncatedText>Class of {ClassYearFormat.Fields.graduationYear(classYear.graduationYear)}</TruncatedText>
						</Row>
					</Badge>
				</Row>
			</Column>

			<DetailFormModalController
				heading="Edit Class Year"
				DetailForm={ClassYearForm.ControlledDetail}
				instanceName="classYear"
				instance={classYear}
			/>
		</Row>
	);
}
